import type { ContentNode } from "lib/types";

export const SOFT_HYPHEN = "\u00AD";
const SOFT_HYPHEN_RE = new RegExp(SOFT_HYPHEN, "g");

export function stripSoftHyphens(text: string): string {
  return text.replace(SOFT_HYPHEN_RE, "");
}

export function extractVisibleText(node: ContentNode): string {
  if (!node.c) return "";

  let text = "";
  for (const child of node.c) {
    if (typeof child === "string") {
      text += stripSoftHyphens(child);
    } else {
      text += extractVisibleText(child);
    }
  }
  return text;
}

export function extractVisibleTextFromElement(element: Element): string {
  const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null);
  let text = "";
  let node: Text | null;

  while ((node = walker.nextNode() as Text | null)) {
    text += node.textContent || "";
  }

  return stripSoftHyphens(text);
}

export function getVisibleLength(node: ContentNode): number {
  return extractVisibleText(node).length;
}
